import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../context/I18nContext";
import Logo from "../components/Logo";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function Login() {
  const { t } = useI18n();
  const { login, loginWithGoogle } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const u = await login(email, password);
      nav(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2?.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[78vh] flex items-center justify-center px-6 py-16" style={{ background: "var(--gai-white)" }} data-testid="page-login">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo size={64} /></div>
        <div className="text-center">
          <div className="text-[0.66rem] font-bold tracking-[0.24em] uppercase mb-3" style={{ color: "var(--gai-red)" }}>Accès</div>
          <h1 className="serif text-4xl" style={{ color: "var(--gai-black)", fontFamily: "'Playfair Display', serif" }}>{t("auth.loginTitle")}</h1>
          <p className="mt-3" style={{ color: "var(--gai-grey-600)" }}>{t("auth.loginSub")}</p>
        </div>

        <form onSubmit={submit} className="mt-10 space-y-5" data-testid="login-form">
          <div>
            <label className="gai-label">{t("auth.email")}</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="gai-input" data-testid="login-email" />
          </div>
          <div>
            <label className="gai-label">{t("auth.password")}</label>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="gai-input" data-testid="login-password" />
          </div>
          {err && <div className="text-sm p-3" style={{ background: "var(--gai-red-soft)", color: "var(--gai-red-ink)", border: "1px solid var(--gai-red)" }} data-testid="login-error">{err}</div>}
          <button disabled={loading} className="gai-btn-gold w-full justify-center" data-testid="login-submit">
            {loading ? t("common.sending") : t("auth.login")}
          </button>
        </form>

        <div className="my-8 flex items-center gap-4 text-[0.68rem] tracking-[0.22em] uppercase" style={{ color: "var(--gai-grey-500)" }}>
          <span className="flex-1 h-px" style={{ background: "var(--gai-grey-200)" }} />
          <span>Ou</span>
          <span className="flex-1 h-px" style={{ background: "var(--gai-grey-200)" }} />
        </div>

        <button onClick={loginWithGoogle} className="gai-btn-outline w-full justify-center" data-testid="login-google">
          {t("auth.google")}
        </button>

        <p className="mt-10 text-center text-sm" style={{ color: "var(--gai-grey-600)" }}>
          {t("auth.noAccount")} <Link to="/inscription" className="font-semibold" style={{ color: "var(--gai-red)" }} data-testid="login-register-link">{t("auth.createOne")}</Link>
        </p>
      </div>
    </div>
  );
}
